/**
 * Dati finti per la sola card dello scaffold.
 * Profilo sintetico "Anna, 74" (PRIVACY §6): nessun dato reale finche DEC-06 e aperta.
 * Testo preso da `design/directions/d03-aria.html`, la direzione approvata.
 */
import type { WizardCardProps } from './components/WizardCard'

export const CARD_MOCK: WizardCardProps = {
  block: 'Le sue giornate',
  progress: 'Parte 3 di 12',
  question: 'A che ora si sveglia di solito?',
  why: 'Mi serve per non disturbarla troppo presto e per mettere i promemoria a un’ora sensata.',
  choices: ['Verso le 7', 'Verso le 8', 'Dipende dal giorno'],
  fieldLabel: 'Oppure scriva qui',
  skipKinds: [
    { kind: 'salta', label: 'Salta' },
    { kind: 'non_so', label: 'Non so' },
    { kind: 'non_ora', label: 'Non ora' },
  ],
  askAgentLabel: 'Chiedi a mia Tina',
}
